import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/**
 * Alacak yaşlandırma — `GET /api/reports/receivables-aging` (O3).
 *
 * Sunucu FIFO yaşlandırmayı yapıp müşterileri "aranacaklar" sırasıyla döner (oldestDays
 * azalan, eşitse bakiye azalan). Panel yalnız ekrana yansıtır; para hesabı yok (kural 4).
 *
 * Bu dosya `apps/panel/src/api/reports.ts` ile AYNI eğilimde — endpoint'in tipi ve hook'u
 * yeni dosyada duruyor; raporlar ekranı sıralı dosyalarla büyümesin diye ayrı tuttuk.
 */

export interface ReceivablesAgingBucket {
  b0_30: string;
  b31_60: string;
  b61_90: string;
  b90p: string;
}

export interface ReceivablesAgingCustomer {
  customerId: string;
  name: string;
  /** Anonimleştirilmiş müşterilerde null. */
  phone: string | null;
  anonymized: boolean;
  balance: string;
  buckets: ReceivablesAgingBucket;
  /** ISO "YYYY-MM-DD"; en eski ödenmemiş kalemin Istanbul günü. */
  oldestUnpaidAt: string | null;
  /** asOf ile oldestUnpaidAt gün farkı. */
  oldestDays: number | null;
  /** ISO 8601 UTC; son tahsilat. */
  lastPaymentAt: string | null;
}

export interface ReceivablesAgingResponse {
  asOf: string;
  totals: ReceivablesAgingBucket & { total: string };
  customers: ReceivablesAgingCustomer[];
}

/** `asOf` YOKSA sunucu İstanbul bugününü kullanır (test/snapshot için). */
export function useReceivablesAging(asOf?: string) {
  const qs = asOf ? `?asOf=${encodeURIComponent(asOf)}` : '';
  return useQuery({
    queryKey: ['receivables-aging', qs],
    queryFn: () => api.get<ReceivablesAgingResponse>(`/api/reports/receivables-aging${qs}`),
    // Yaşlandırma gün içinde değişmez; tekrarlı güncelleme gereksiz.
    staleTime: 60_000,
  });
}
